import Vue from "vue";
import environmentLinkBase, { husBvgLink } from "./envdetect";
import clientContext from "./clientcontextdetect";
import resizeImage from "./resizeimagedata";
import moment from "moment";

// import encoding from "../../services/EncodingService";

// let environmentLinkBase = "https://bitve190.vis-extranet.de:31443/";

const state = {
  assortment: [
    {
      index: 1,
      label: "Mobilgerät",
      assortmentDescription: "Smartphone, Handy, Tablet oder iPad"
    },
    {
      index: 2,
      label: "Computer",
      assortmentDescription:
        "Laptop, MacBook, Chromebook, PC, Convertible, Monitor; \n" +
        "Tastatur, Headset, Mikrofon oder Maus (müssen wenn gewünscht einzeln versichert werden)"
    },
    {
      index: 3,
      label: "Fernseher",
      assortmentDescription: "Fernseher oder Monitor "
    },
    {
      index: 4,
      label: "Armbanduhr",
      assortmentDescription: "Analoge, digitale oder smarte Armbanduhr"
    },
    {
      index: 5,
      label: "Lautsprecher",
      assortmentDescription:
        "Bluetooth-, PC- oder Lautsprecher von Stereo-Anlagen"
    },
    {
      index: 6,
      label: "Schmuck",
      assortmentDescription:
        "Ohrringe (paarweise), Kette, Armband, Ring, Fußkettchen, Brosche, Diadem oder Haarspange"
    },
    {
      index: 7,
      label: "Kamera",
      assortmentDescription:
        "Actioncam, analoge oder digitale Foto- & Videokamera (hier ist der Kamerabody und EIN Objektiv abgesichert) "
    },
    {
      index: 8,
      label: "Tasche",
      assortmentDescription:
        "Handtasche, Umhängetasche, Aktentasche, Rucksack oder Turnbeutel "
    },
    {
      index: 9,
      label: "Haushaltsgerät",
      assortmentDescription:
        "Thermomix, Ofen, Herd, Kühlschrank, Gefrierschrank, Waschmaschine, Spülmaschine, Trockner, Kaffeemaschine oder Mikrowelle"
    },
    {
      index: 10,
      label: "Kopfhörer",
      assortmentDescription: "Kopfhörer (Funk z.B. Bluetooth oder Kabel) "
    },
    {
      index: 11,
      label: "Musikinstrument",
      assortmentDescription:
        "Analoges oder elektronisches Musikinstument von A wie Adiaphon bis Z wie Zymbal "
    },
    {
      index: 12,
      label: "Sportartikel",
      assortmentDescription:
        "Sportgerät wie z.B. Skateboard, Skier (paarweise), Hantelbank oder Wakeboard."
    },
    {
      index: 13,
      label: "Spielekonsole",
      assortmentDescription:
        "Spielekonsole wie z.B. Xbox, Playstation, Nintendo; \n" +
        "Controller oder Spiel (müssen wenn gewünscht einzeln versichert werden)"
    },
    {
      index: 14,
      label: "Musikanlage",
      assortmentDescription: "Verstärker, Player, Boxen oder Kopfhörer"
    },
    {
      index: 15,
      label: "Mobiliar",
      assortmentDescription:
        "Sofa, Bett, Schrank, Tisch, Kommode, Küchenzeile (ohne elektrische Geräte), Stuhl-Set oder Sekretär"
    },
    {
      index: 16,
      label: "Sonstiges",
      assortmentDescription:
        "Brille, Kleidungsstück, Schuhe (paarweise), Aquarium (ohne Inhalt), Drohne bis 5 kg, Smart Home Device, Drucker, Mikrofon, Bollerwagen, Modellfahrzeuge oder Werkzeug wie z.B. Bohrmaschine"
    }
  ],
  forxchange: {
    offerRequest: {
      policyholder: {
        name: "",
        lastname: "",
        street: "",
        housenr: "",
        zip: "",
        city: "",
        salutation: "1",
        birthdate: "",
        phone: "",
        email: "",
        emailRepeated: "",
        iban: "",
        partnernummer: ""
      },
      properties: {
        werbung: false,
        beratungverz: false,
        sepa: false,
        agb: false,
        ONLINE_PROPERTIES_HOST: ""
      },
      contract: {
        beginn: "",
        policy: "",
        polpr: "",
        salesagent_nr: "",
        salesagent_nr_raw: "",
        variante: "1" /* (1 = bis 30, 2 = Über 30 ) */,
        gesamtbeitrag: 0,
        products: []
      },
      createDocument: false,
      document: {
        data: "",
        hint:
          "data string is a base64 encoded binary string of a blob (Blob -> readAsBinaryString -> base64)",
        filename: "Versicherungsschein.pdf",
        contenttype: "application/pdf"
      },
      documents_in: []
    },
    error: false,
    messages: [
      {
        field: "",
        type: "",
        message: ""
      }
    ]
  },
  contractAcceptanceState: false,
  cookieBirthdate: {
    tooYoung: false,
    invalid: false,
    showSelectNew: false
  },
  dialogProductDataInputState: {
    selectedProductIndex: 0,
    show: false
  },
  supposedlyYoungerThan32: true,
  supposedlyAgeGroup: "0",
  supposedlyAge: 18,
  prices: {
    single: {
      to31: 2,
      from32: 4
    },
    total: 0
  },
  links: {
    HUS_IPID_VG:
      environmentLinkBase +
      "FormularDBNew/Suche?unid=5F74F6561EA2D309C12583F2004606B8&dok=HUS_IPID_VG_2019-05.pdf&",
    HUS_BVG: husBvgLink,
    Datenschutz_und_HIS:
      environmentLinkBase +
      "FormularDBNew/Suche?unid=CAD9CBB5251E8C82C1257E2A0026B46C&dok=Datenschutzhinweise%20Oeffentliche%20und%20Datenaustausch%20mit%20HIS.pdf"
  },
  clientContext: clientContext,
  camera: {
    tested: false,
    available: false
  },
  runIconAnimation: false,
  ignoreZipCodeCheck: false,
  ignoreAgeCheck: false,
  kanalType: "",
  internal: {
    selectedAgency: {
      number: "",
      shortDescription: "",
      imageUrl: ""
    }
  },
  checkIsCalled: false,
  isOnlineGs: false,
  hasCookie: false,
  warningHasBeenShown: false
};

/*
 *√************************ MUTATIONS ************************
 */

const mutations = {
  SET_IS_ONLINE_GS: (state, value) => {
    state.isOnlineGs = value;
  },
  SET_ONLINE_PROPERTIES_HOST: (state, value) => {
    state.ONLINE_PROPERTIES_HOST = value;
    state.forxchange.offerRequest.properties.ONLINE_PROPERTIES_HOST = value;
  },
  HAS_COOKIE: (state, value) => {
    state.hasCookie = value;
  },
  SET_WARNING_HAS_BEEN_SHOWN: (state, value) => {
    state.warningHasBeenShown = value;
  },
  STORE_COOKIE_DATA: (state, cookieDataObj) => {
    // let cookieDataObj = JSON.parse(cookieDataString);
    // if(cookieDataObj.salutation=='Herr') { cookieDataObj.salutation = 1; }
    // cookieDataObj.salutation = (cookieDataObj.salutation == 'Herr') ? '1' : '2';
    state.forxchange.offerRequest.contract.salesagent_nr_raw =
      cookieDataObj.contract.salesagent_nr;
    state.forxchange.offerRequest.contract.salesagent_nr = state.forxchange.offerRequest.contract.salesagent_nr_raw.split(
      "_"
    )[0];
    state.forxchange.offerRequest.policyholder.partner_id =
      cookieDataObj.policyholder.partnernummer;
    state.forxchange.offerRequest.policyholder.name =
      cookieDataObj.policyholder.name;
    state.forxchange.offerRequest.policyholder.lastname =
      cookieDataObj.policyholder.lastname;
    state.forxchange.offerRequest.policyholder.street =
      cookieDataObj.policyholder.street;
    state.forxchange.offerRequest.policyholder.housenr =
      cookieDataObj.policyholder.housenr;
    state.forxchange.offerRequest.policyholder.city =
      cookieDataObj.policyholder.city;
    state.forxchange.offerRequest.policyholder.salutation =
      cookieDataObj.policyholder.salutation == "1" ? "1" : "2";
    state.forxchange.offerRequest.policyholder.phone =
      cookieDataObj.policyholder.phone;
    state.forxchange.offerRequest.policyholder.email =
      cookieDataObj.policyholder.email;
    state.forxchange.offerRequest.policyholder.emailRepeated =
      cookieDataObj.policyholder.email;
    state.forxchange.offerRequest.policyholder.iban =
      cookieDataObj.policyholder.iban;
    state.forxchange.offerRequest.policyholder.birthdate =
      cookieDataObj.policyholder.birthdate;
    state.forxchange.offerRequest.policyholder.zip =
      cookieDataObj.policyholder.zip;
  },
  SET_COOKIEBIRTHDATE_INVALID: (state, value) => {
    state.cookieBirthdate.invalid = value;
  },
  SET_COOKIEBIRTHDATE_TOOYOUNG: (state, value) => {
    state.cookieBirthdate.tooYoung = value;
  },
  SET_SHOW_SELECT_NEW: (state, value) => {
    state.cookieBirthdate.showSelectNew = value;
  },
  SET_SELECTED_AGENCY_NUMBER: (state, agencyNumber) => {
    Vue.set(state.internal.selectedAgency, "number", agencyNumber);
  },
  SET_SELECTED_AGENCY_SHORT_DESCRIPTION: (state, agencyShortDescription) => {
    Vue.set(
      state.internal.selectedAgency,
      "shortDescription",
      agencyShortDescription
    );
  },
  SET_SELECTED_AGENCY_IMAGE_URL: (state, agencyImageUrl) => {
    Vue.set(state.internal.selectedAgency, "imageUrl", agencyImageUrl);
  },
  SET_KANALTYPE: (state, kanalType) => {
    state.kanalType = kanalType;
  },
  /* SET_SALESAGENT_NR: (state, value) => {
    state.forxchange.offerRequest.contract.salesagent_nr = value;
  }, */
  SET_SALESAGENT_NR: (state, agent) => {
    state.forxchange.offerRequest.contract.salesagent_nr_raw = agent;
    state.forxchange.offerRequest.contract.salesagent_nr = agent.split("_")[0];
  },
  SET_SALESAGENT_NR_SUBSEQUENTLY: (state, value) => {
    state.forxchange.offerRequest.contract.salesagent_nr = value;
  },
  IGNORE_ZIPCODE_CHECK: state => {
    state.ignoreZipCodeCheck = true;
  },
  IGNORE_AGE_CHECK: state => {
    state.ignoreAgeCheck = true;
  },
  IMPORT_CHECKSERVICE_RESPONSE: (state, contract) => {
    state.forxchange.offerRequest.contract.policy = contract.policy;
    state.forxchange.offerRequest.contract.polpr = contract.polpr;
    if (contract.policyholder && contract.policyholder.partnernummer) {
      state.forxchange.offerRequest.policyholder.partnernummer = contract.policyholder.partnernummer;
    }
  },
  SET_CHECK_IS_CALLED: (state, value) => {
    state.checkIsCalled = value;
  },
  SET_CAMERA_AVAILABLE: (state, value) => {
    state.camera.tested = true;
    state.camera.available = value;
  },
  SET_POLICY_DOCUMENT: (state, policy) => {
    state.forxchange.offerRequest.document.data = policy;
    // let responseArray = new Uint8Array(data); // array of 8-bit unsigned integers
    // console.dir(responseArray);
    // let s = new TextDecoder("utf-8").decode(data);
    // console.dir(s);

    // let str = btoa(String.fromCharCode.apply(null, new Uint8Array(pdfBlob)));
    // let str = btoa(String.fromCharCode(...new Uint8Array(pdfBlob)));
    // let str = btoa([].reduce.call(new Uint8Array(pdfBlob),function(p,c){return p+String.fromCharCode(c)},''));
    // console.log(str);
    // state.forxchange.offerRequest.document.data = str; // btoa(s);
    // console.log("Nach der Zuweisung");
    // console.log("str = " + str);
    /* pdf is a Blob! */
    /*
    var reader = new FileReader();
    reader.readAsBinaryString(pdfBlob);
    // reader.readAsArrayBuffer(pdfBlob);
    reader.onload = function () {
      // console.log(reader.result);
      state.forxchange.offerRequest.document.data = btoa(reader.result);
    }
    */
  },
  SET_POLICY_DOCUMENT_FAKE: state => {
    state.forxchange.offerRequest.document.data = "Fixer String als Testinhalt";
  },
  SET_CONTRACT_ACCEPTANCE_STATE: (state, value) => {
    state.contractAcceptanceState = value;
  },
  SET_SUPPOSEDLY_AGE: (state, value) => {
    state.supposedlyAge = value;
  },
  SET_SUPPOSEDLY_AGEGROUP: (state, value) => {
    state.supposedlyAgeGroup = value;
    state.supposedlyYoungerThan32 = state.supposedlyAgeGroup == "1";
    state.forxchange.offerRequest.contract.variante = value;
  },
  SELECT_PRODUCT: (state, index) => {
    let assortmentProd = state.assortment.find(
      obj => obj != undefined && obj.index == index
    );
    let selectedProd = JSON.parse(JSON.stringify(assortmentProd)); // deep clone!
    selectedProd.pictures = []; // later addition of property pictures causes reactivity problems, therefor: property definition now!
    selectedProd.files = [];
    selectedProd.producer = "";
    selectedProd.description = "";
    selectedProd.imei = "";
    selectedProd.inputProgress = "25";
    state.forxchange.offerRequest.contract.products.push(selectedProd);
  },
  UPDATE_DATA_INPUT_PROGRESS: (state, index) => {
    if (state.forxchange.offerRequest.contract.products[index] == undefined)
      return;
    let progress = 100;
    let hasImeiPic = false;
    if (
      state.forxchange.offerRequest.contract.products[index].pictures.length ===
      0 &&
      state.forxchange.offerRequest.contract.products[index].index >= 2
    ) {
      progress -= 50;
    }
    if (
      state.forxchange.offerRequest.contract.products[index].producer === ""
    ) {
      progress -= 25;
    }
    for (
      let i = 0;
      i <
      state.forxchange.offerRequest.contract.products[index].pictures.length;
      i++
    ) {
      if (
        state.forxchange.offerRequest.contract.products[index].pictures[i]
          .intendedImageType == "IMEI"
      ) {
        hasImeiPic = true;
      }
    }
    if (
      state.forxchange.offerRequest.contract.products[index].index < 2 &&
      state.forxchange.offerRequest.contract.products[index].imei === "" &&
      !hasImeiPic
    ) {
      progress -= 50;
    }
    if (
      state.forxchange.offerRequest.contract.products[index].index == 2 &&
      state.forxchange.offerRequest.contract.products[index].imei === ""
    ) {
      progress -= 25;
    }
    if (progress < 0) {
      progress = 0;
    }
    state.forxchange.offerRequest.contract.products[
      index
    ].inputProgress = progress;
  },
  CALCULATE_TOTAL_PRICE: state => {
    let ppu = state.supposedlyYoungerThan32
      ? state.prices.single.to31
      : state.prices.single.from32;
    let quantity = state.forxchange.offerRequest.contract.products.length;
    let factor = quantity;
    if (quantity == 4) {
      factor = 3;
    }
    state.forxchange.offerRequest.contract.gesamtbeitrag = ppu * factor;
  },
  SET_CONTRACT_BEGIN: (state, value) => {
    state.forxchange.offerRequest.contract.beginn = value;
  },
  SET_PH_SALUTATION: (state, value) => {
    state.forxchange.offerRequest.policyholder.salutation = value;
  },
  SET_PH_NAME: (state, value) => {
    state.forxchange.offerRequest.policyholder.name = value;
  },
  SET_PH_LASTNAME: (state, value) => {
    state.forxchange.offerRequest.policyholder.lastname = value;
  },
  SET_PH_STREET: (state, value) => {
    state.forxchange.offerRequest.policyholder.street = value;
  },
  SET_PH_HOUSENR: (state, value) => {
    state.forxchange.offerRequest.policyholder.housenr = value;
  },
  SET_PH_ZIP: (state, value) => {
    state.forxchange.offerRequest.policyholder.zip = value;
  },
  SET_PH_CITY: (state, value) => {
    state.forxchange.offerRequest.policyholder.city = value;
  },
  SET_PH_BIRTHDATE: (state, value) => {
    state.forxchange.offerRequest.policyholder.birthdate = value;
  },
  SET_PH_EMAIL: (state, value) => {
    state.forxchange.offerRequest.policyholder.email = value;
  },
  SET_PH_EMAILREPEATED: (state, value) => {
    state.forxchange.offerRequest.policyholder.emailRepeated = value;
  },
  SET_PH_PHONE: (state, value) => {
    state.forxchange.offerRequest.policyholder.phone = value;
  },
  SET_PH_IBAN: (state, value) => {
    state.forxchange.offerRequest.policyholder.iban = value;
  },
  SET_PH_SEPA: (state, value) => {
    state.forxchange.offerRequest.properties.sepa = value;
  },
  SET_PROP_BERATUNGVERZICHT: (state, value) => {
    state.forxchange.offerRequest.properties.beratungverz = value;
  },
  SET_PROP_WERBUNG: (state, value) => {
    state.forxchange.offerRequest.properties.werbung = value;
  },
  SET_PROP_AGB: (state, value) => {
    state.forxchange.offerRequest.properties.agb = value;
  },

  SET_PRODUCT_STATUS_DEFAULT: (state, index) => {
    let positionInArray = state.forxchange.offerRequest.contract.products.findIndex(
      function (item) {
        return item != undefined && item.index == index;
      }
    );
    // console.log("Position im Array ist: " + positionInArray);
    state.forxchange.offerRequest.contract.products[
      positionInArray
    ].inputStatus = "withProductNoData";
  },
  DELETE_PRODUCT: (state, index) => {
    /* Achtung: index muss der index im Array products sein, nicht die Eigenschaft index des Produkts */
    state.forxchange.offerRequest.contract.products.splice(index, 1);
  },
  STORE_PRODUCT_PHOTO: (state, photoDataObject) => {
    state.forxchange.offerRequest.contract.products[
      photoDataObject.contractProductIndex
    ].pictures.push({
      data: photoDataObject.imageData,
      fileType: photoDataObject.imageType,
      intendedImageType: "Produkt",
      fileName: photoDataObject.fileName
    });
  },
  STORE_IMEI_PHOTO: (state, photoDataObject) => {
    state.forxchange.offerRequest.contract.products[
      photoDataObject.contractProductIndex
    ].pictures.push({
      data: photoDataObject.imageData,
      intendedImageType: "IMEI",
      fileType: photoDataObject.imageType,
      fileName: photoDataObject.fileName
    });
  },
  REMOVE_IMAGE: (state, imageDataSet) => {
    let positionInArray = state.forxchange.offerRequest.contract.products[
      imageDataSet.contractProductIndex
    ].pictures.findIndex(function (item) {
      return item != undefined && item.fileName == imageDataSet.fileName;
    });
    state.forxchange.offerRequest.contract.products[
      imageDataSet.contractProductIndex
    ].pictures.splice(positionInArray, 1);
  },
  REMOVE_PDF: (state, fileDataSet) => {
    let positionInArray = state.forxchange.offerRequest.contract.products[
      fileDataSet.contractProductIndex
    ].files.findIndex(function (item) {
      return item != undefined && item.fileName == fileDataSet.fileName;
    });
    state.forxchange.offerRequest.contract.products[
      fileDataSet.contractProductIndex
    ].files.splice(positionInArray, 1);
  },
  STORE_PRODUCT_PDF: (state, fileDataObject) => {
    state.forxchange.offerRequest.contract.products[
      fileDataObject.contractProductIndex
    ].files.push({
      data: fileDataObject.fileData,
      fileType: "pdf",
      fileName: fileDataObject.fileName
    });
  },
  STORE_PRODUCT_DESCRIPTION: (state, descriptionSet) => {
    state.forxchange.offerRequest.contract.products[
      descriptionSet.index
    ].description = descriptionSet.text;
  },
  STORE_PRODUCT_IMEI: (state, descriptionSet) => {
    state.forxchange.offerRequest.contract.products[descriptionSet.index].imei =
      descriptionSet.text;
  },
  STORE_PRODUCT_PRODUCER: (state, producerSet) => {
    state.forxchange.offerRequest.contract.products[
      producerSet.index
    ].producer = producerSet.text;
  },
  SET_DIALOG_PRODUCTDATAINPUT_STATE: (state, dialogState) => {
    state.dialogProductDataInputState.selectedProductIndex =
      dialogState.selectedProductIndex;
    state.dialogProductDataInputState.show = dialogState.show;
  },
  SET_RUN_ICON_ANIMATION: (state, animationWanted) => {
    state.runIconAnimation = animationWanted;
  },
  REINDEX_SELECTED_PRODUCTS_ARRAY: state => {
    // state.forxchange.offerRequest.contract.products = state.forxchange.offerRequest.contract.products.filter(val => val);
  },
  GENERATE_TEST_DATA: state => {
    state.forxchange.offerRequest.contract.policy = "0000001234";
    state.forxchange.offerRequest.policyholder.iban = "DE91100000000123456789";
    state.forxchange.offerRequest.contract.beginn = "2020-02-29";
    // state.forxchange.offerRequest.contract.beginn = "2020-01-31";
  }
};

/*
 *√************************ ACTIONS ************************
 */

const actions = {
  readCookie: ({ commit, dispatch }, cookieName) => {
    let cookieDataObject = Vue.$cookies.get(cookieName);
    if (cookieDataObject != undefined && cookieDataObject != null) {
      // console.debug("Cookie " + cookieName + " gefunden.");
      commit("HAS_COOKIE", true);
      commit("STORE_COOKIE_DATA", cookieDataObject);
      dispatch("setSupposedlyAgeByCookie");
      dispatch("checkCookieBirthdate");
      Vue.$cookies.remove(cookieName);
      // console.debug("Cookie " + cookieName + " entfernt.");
      commit("IGNORE_ZIPCODE_CHECK");
      commit("IGNORE_AGE_CHECK");
    } else {
      // console.debug("Cookie " + cookieName + " ist nicht vorhanden.");
      commit("HAS_COOKIE", false);
    }
  },
  checkHost: async ({ state, commit, dispatch }) => {
    // const referrer = document.referrer;
    // console.log("Aufruf von checkHost");
    const hostname = await dispatch("detectHostname");
    // console.log("hostname = " + hostname);
    const isProd = hostname && hostname.includes("www.oeffentliche.de");
    const isRed = hostname && hostname.includes("r.oevcloud.de");
    const isSkDev = hostname && hostname.includes("4g.cleverads.de");
    const isLocal = hostname && hostname.includes("localhost");
    const isOnlineGs = !isProd && !isRed && !isSkDev && !isLocal;
    // console.log("checkHost - referrer = " + referrer);
    // console.log("isOnlineGs = ", isOnlineGs);
    // new: check Cookie (necessary in case of reload)
    const referrerCookieExists = Vue.$cookies.isKey("FourGReferrer");
    if (referrerCookieExists === true) {
      const referrerCookie = Vue.$cookies.get("FourGReferrer");
      commit("SET_IS_ONLINE_GS", referrerCookie == "true" ? true : false);
      commit("SET_ONLINE_PROPERTIES_HOST", hostname);
    } else {
      commit("SET_IS_ONLINE_GS", isOnlineGs);
      commit("SET_ONLINE_PROPERTIES_HOST", hostname);
      const host = window.location.host; // tld, domain and subdomain
      try {
        Vue.$cookies.set(
          "FourGReferrer",
          state.isOnlineGs.toString()/* ,
          null,
          null,
          host */
        );
      } catch (error) {
        console.error(
          "cookie schreiben hat nicht funktioniert. Meldung: " + error
        );
      }

    }
  },
  detectHostname: async ({ state, dispatch }) => {
    // Versuch, den Hostnamen über document.referrer zu ermitteln
    /* console.log(
      "In detectHostname ist document.referrer = " + document.referrer
    ); */
    if (document.referrer && document.referrer !== "") {
      try {
        const referrerUrl = new URL(document.referrer);
        return referrerUrl.hostname;
      } catch (error) {
        console.error("Fehler beim Parsen des Referrers", error);
      }
    }

    // Versuch, den Hostnamen über window.location zu ermitteln
    try {
      if (window.location !== window.parent.location) {
        const parentUrl = new URL(window.parent.location.href);
        return parentUrl.hostname;
      }
    } catch (error) {
      // Bei Sicherheitsfehlern wird window.postMessage verwendet
      dispatch("requestHostnameFromParent");
      return "wait for postMessage";
    }
    dispatch("requestHostnameFromParent");
    return "wait for postMessage";
  },
  requestHostnameFromParent: () => {
    // will be called when referrer and parent.location.href are not available
    window.parent.postMessage({ action: "requestHostname" }, "*");
  },
  receiveHostnameFromParent: hostname => {
    const isProd = hostname && hostname.includes("www.oeffentliche.de");
    const isRed = hostname && hostname.includes("r.oevcloud.de");
    const isSkDev = hostname && hostname.includes("4g.cleverads.de");
    const isLocal = hostname && hostname.includes("localhost");
    const isOnlineGs = !isProd && !isRed && !isSkDev && !isLocal;
    // new: check Cookie (necessary in case of reload)
    const referrerCookieExists = Vue.$cookies.isKey("FourGReferrer");
    if (referrerCookieExists === true) {
      const referrerCookie = Vue.$cookies.get("FourGReferrer");
      commit("SET_IS_ONLINE_GS", referrerCookie == "true" ? true : false);
      commit("SET_ONLINE_PROPERTIES_HOST", hostname);
    } else {
      commit("SET_IS_ONLINE_GS", isOnlineGs);
      commit("SET_ONLINE_PROPERTIES_HOST", hostname);
      const host = window.location.host; // tld, domain and subdomain
      Vue.$cookies.set(
        "FourGReferrer",
        state.isOnlineGs.toString()/* ,
        null,
        null,
        host */
      );
    }
  },
  checkCookieBirthdate: ({ state, commit }) => {
    commit(
      "SET_COOKIEBIRTHDATE_INVALID",
      !moment(state.forxchange.offerRequest.policyholder.birthdate).isValid()
    );
    commit("SET_COOKIEBIRTHDATE_TOOYOUNG", state.supposedlyAgeGroup === 0);
  },
  setSupposedlyAgeByCookie: ({ getters, commit }) => {
    const age = moment().diff(getters.getBirthdate, "years");
    const minAge = getters.getIsOnlineGs ? 16 : 18;
    commit("SET_SUPPOSEDLY_AGE", age);
    const group = age < minAge ? 0 : age <= 30 ? 1 : 2;
    commit("SET_SUPPOSEDLY_AGEGROUP", group);
  },
  selectProduct: ({ commit }, index) => {
    commit("SELECT_PRODUCT", index);
    commit("SET_PRODUCT_STATUS_DEFAULT", index);
    commit("CALCULATE_TOTAL_PRICE");
  },
  deleteProduct: ({ commit }, index) => {
    /* Entferne das Produkt aus dem Vertrag */
    // console.log("deleteProduct arbeitet mit index " + index);
    commit("DELETE_PRODUCT", index);
    commit("CALCULATE_TOTAL_PRICE");
    commit("UPDATE_DATA_INPUT_PROGRESS", index);
  },
  storeProductPhoto: ({ commit, dispatch }, photoDataObject) => {
    resizeImage(photoDataObject).then(function (response) {
      photoDataObject.imageData = response;
      commit("STORE_PRODUCT_PHOTO", photoDataObject);
      commit("REINDEX_SELECTED_PRODUCTS_ARRAY");
      commit(
        "UPDATE_DATA_INPUT_PROGRESS",
        photoDataObject.contractProductIndex
      );
    });
  },
  storeImeiPhoto: ({ commit }, photoDataObject) => {
    commit("STORE_IMEI_PHOTO", photoDataObject);
    commit("REINDEX_SELECTED_PRODUCTS_ARRAY");
    commit("UPDATE_DATA_INPUT_PROGRESS", photoDataObject.contractProductIndex);
  },
  removeImage: ({ commit }, imageDataSet) => {
    commit("REMOVE_IMAGE", imageDataSet);
    commit("UPDATE_DATA_INPUT_PROGRESS", imageDataSet.contractProductIndex);
  },
  removePdf: ({ commit }, fileDataSet) => {
    commit("REMOVE_PDF", fileDataSet);
  },
  storeProductPdf: ({ commit }, fileDataObject) => {
    commit("STORE_PRODUCT_PDF", fileDataObject);
    commit("REINDEX_SELECTED_PRODUCTS_ARRAY");
    commit("UPDATE_DATA_INPUT_PROGRESS", fileDataObject.contractProductIndex);
  },
  setProductDescription: ({ commit, getters }, descriptionSet) => {
    commit("STORE_PRODUCT_DESCRIPTION", descriptionSet);
    commit("REINDEX_SELECTED_PRODUCTS_ARRAY");
    // commit("UPDATE_DATA_INPUT_PROGRESS",descriptionSet.index);
  },
  setProductImei: ({ commit, getters }, descriptionSet) => {
    commit("STORE_PRODUCT_IMEI", descriptionSet);
    commit("REINDEX_SELECTED_PRODUCTS_ARRAY");
    commit("UPDATE_DATA_INPUT_PROGRESS", descriptionSet.index);
  },
  setProductProducer: ({ commit, getters }, producerSet) => {
    commit("STORE_PRODUCT_PRODUCER", producerSet);
    commit("REINDEX_SELECTED_PRODUCTS_ARRAY");
    commit("UPDATE_DATA_INPUT_PROGRESS", producerSet.index);
  },
  setDialogProductDataInputState: ({ commit }, dialogState) => {
    commit("SET_DIALOG_PRODUCTDATAINPUT_STATE", dialogState);
  },
  setRunIconAnimation: ({ commit }, animationWanted) => {
    commit("SET_RUN_ICON_ANIMATION", animationWanted);
  },

  /* postMessage actions für die Kommunikation mit der parent Seite */

  postMessageNewHeight: () => {
    if (parent) {
      var newHeight = document.getElementById("vier-gewinnt-app").offsetHeight;
      var stumpferAufschlag = 0; // Pixel für die iframe-Höhe
      parent.postMessage(
        {
          id: "height",
          content: newHeight + stumpferAufschlag
        },
        "*"
      );
    }
  },
  postMessageAppendedHint: ({ }, hint) => {
    if (parent) {
      parent.postMessage(
        {
          id: "sk_4g_appendedHint",
          content: hint
        },
        "*"
      );
    }
  },
  postMessageNewMessage: ({ getters }, html) => {
    // console.log("html = " + html);
    if (parent) {
      parent.postMessage(
        {
          id: "sk_4g_message",
          content: html
        },
        "*"
      );
    }
  },
  postMessageNewPrice: ({ getters }) => {
    if (parent) {
      let price = getters.getPriceTotal;
      if (price > 0) {
        parent.postMessage(
          {
            id: "sk_4g_p3",
            content:
              "<strong>Gesamtpreis</strong> für diese Gegenstände: " +
              price +
              ",00 Euro monatlich."
          },
          "*"
        );
      }
    }
  },
  postMessageNewSelection: ({ getters }) => {
    if (parent) {
      let prods = getters.getSelectedProducts;
      // let selection = prods.toString();
      let selection = "<strong>Ausgewählte Gegenstände</strong>:<br><ul>";
      for (let i = 0; i < prods.length; i++) {
        selection += "<li>" + prods[i].label;
        if (prods[i].producer.length > 0) {
          selection += " (" + prods[i].producer + ")";
        }
        selection += "</li>";
      }
      selection += "</ul>";
      parent.postMessage(
        {
          id: "sk_4g_p2",
          content: selection
        },
        "*"
      );
    }
  },
  postMessageReload: () => {
    if (parent) {
      parent.postMessage(
        {
          id: "sk_4g_p1",
          content: ""
        },
        "*"
      );
      parent.postMessage(
        {
          id: "sk_4g_p2",
          content: ""
        },
        "*"
      );
      parent.postMessage(
        {
          id: "sk_4g_p3",
          content: ""
        },
        "*"
      );
      parent.postMessage(
        {
          id: "sk_4g_message",
          content: "<strong>4gewinnt wurde neu geladen!</strong>"
        },
        "*"
      );
    }
  },
  /* Generate test data */
  generateTestData: ({ commit }) => {
    commit("GENERATE_TEST_DATA");
  }
};

/*
 *√************************ GETTERS ************************
 */

const getters = {
  getCookieBirthdateTooYoung: state => {
    return state.cookieBirthdate.tooYoung;
  },
  getCookieBirthdateInvalid: state => {
    return state.cookieBirthdate.invalid;
  },
  getCookieBirthdateShowSelectNew: state => {
    return state.cookieBirthdate.showSelectNew;
  },
  getKanalType: state => {
    return state.kanalType;
  },
  getSalesAgentNr: state => {
    return state.forxchange.offerRequest.contract.salesagent_nr;
  },
  getSalesAgentNrRaw: state => {
    return state.forxchange.offerRequest.contract.salesagent_nr_raw;
  },
  getSelectedAgency: state => {
    return state.internal.selectedAgency;
  },
  getIsOnlineGs: state => {
    return state.isOnlineGs;
  },
  getIgnoreAgeCheck: state => {
    return state.ignoreAgeCheck;
  },
  getSupposedlyAgeGroup: state => {
    return state.supposedlyAgeGroup;
  },
  getContractBegin: state => {
    return state.forxchange.offerRequest.contract.beginn;
  },
  getPriceTotal: state => {
    let ppu = state.supposedlyYoungerThan32
      ? state.prices.single.to31
      : state.prices.single.from32;
    let quantity = state.forxchange.offerRequest.contract.products.length;
    let factor = quantity;
    if (quantity == 4) {
      factor = 3;
    }
    return ppu * factor;
  },
  getAddress: state => {
    let name =
      state.forxchange.offerRequest.policyholder.name +
      " " +
      state.forxchange.offerRequest.policyholder.lastname;
    let street =
      state.forxchange.offerRequest.policyholder.street +
      " " +
      state.forxchange.offerRequest.policyholder.housenr;
    let city =
      state.forxchange.offerRequest.policyholder.zip +
      " " +
      state.forxchange.offerRequest.policyholder.city;
    return name + "<br>" + street + "<br>" + city;
  },
  getBirthdate: state => {
    return state.forxchange.offerRequest.policyholder.birthdate;
  },
  getPhone: state => {
    return state.forxchange.offerRequest.policyholder.phone;
  },
  getEmail: state => {
    return state.forxchange.offerRequest.policyholder.email;
  },
  getIban: state => {
    return state.forxchange.offerRequest.policyholder.iban;
  },
  getProduct: state => index => {
    if (index > 0) {
      let target = state.assortment.find(function (item) {
        return item.index == this;
      }, index);
      if (target != "undefined") {
        return target;
      }
    }
    return { index: -1, label: "Unbekannt" };
  },
  getProductImageSource: state => contractIndex => {
    if (
      state.forxchange.offerRequest.contract.products != undefined &&
      state.forxchange.offerRequest.contract.products[contractIndex] !=
      undefined &&
      state.forxchange.offerRequest.contract.products[contractIndex].pictures !=
      undefined &&
      state.forxchange.offerRequest.contract.products[contractIndex]
        .pictures[0] != undefined &&
      state.forxchange.offerRequest.contract.products[contractIndex].pictures[0]
        .data != undefined
    ) {
      return state.forxchange.offerRequest.contract.products[contractIndex]
        .pictures[0].data;
    }
    if (
      state.forxchange.offerRequest.contract.products[contractIndex] !=
      undefined
    ) {
      return (
        "images/icons/svg/weiss/" +
        state.forxchange.offerRequest.contract.products[contractIndex].index +
        ".svg"
      );
    }
    return "images/icons/svg/weiss/leer.svg";
  },
  getSelectedProducts: state => {
    return state.forxchange.offerRequest.contract.products;
  },
  getSelectedProduct: state => contractIndex => {
    return state.forxchange.offerRequest.contract.products[contractIndex];
  },
  getSelectedProductsLength: state => {
    return state.forxchange.offerRequest.contract.products.length;
  },
  getSelectedProductLabel: state => contractIndex => {
    return state.forxchange.offerRequest.contract.products[contractIndex].label;
  },
  getProductInputStatus: state => index => {
    // console.log("Aufruf von getProductInputStatus mit index = " + index);
    if (
      state.forxchange.offerRequest.contract.products.length == 0 &&
      state.forxchange.offerRequest.contract.products.length > index
    ) {
      return "noProductToShow";
    }
    if (state.forxchange.offerRequest.contract.products[index] == undefined) {
      return "noProductToShow";
    }
    return state.forxchange.offerRequest.contract.products[index].inputStatus;
  },
  getDataInputReadyState: (state, getters) => {
    // TODO: Logik muss noch aufgebaut werden
    // Zu jedem Produkt prüfen: Ist mind. ein Bild vorhanden und ist das erste Textfeld gefüllt
    let item = {};
    let items = getters.getSelectedProducts;
    for (let i = 0; i < items.length; i++) {
      if (getters.getDataInputProgressByIndex(i) < 100) {
        return false;
      }
    }
    return true;
  },
  getDataInputProgressByIndex: state => index => {
    if (state.forxchange.offerRequest.contract.products[index] !== undefined) {
      return state.forxchange.offerRequest.contract.products[index]
        .inputProgress;
    }
  },
  getListOfProductsWithIncompleteDescription: (state, getters) => {
    return state.forxchange.offerRequest.contract.products.filter(
      product => index =>
        getters.getProductHasNoPicture(index) ||
        getters.getProductHasNoProducer(index)
    );
  },
  getProductHasNoPicture: state => index => {
    if (
      state.forxchange.offerRequest.contract.products.length === 0 ||
      state.forxchange.offerRequest.contract.products[index] == undefined ||
      state.forxchange.offerRequest.contract.products[index].pictures ==
      undefined
    ) {
      return true;
    }
    return (
      state.forxchange.offerRequest.contract.products[index].pictures.length ===
      0
    );
  },
  getProductHasNoImeiPicture: state => index => {
    if (
      state.forxchange.offerRequest.contract.products.length === 0 ||
      state.forxchange.offerRequest.contract.products[index] == undefined ||
      state.forxchange.offerRequest.contract.products[index].pictures ==
      undefined
    ) {
      return true;
    }
    for (
      let i = 0;
      i <
      state.forxchange.offerRequest.contract.products[index].pictures.length;
      i++
    ) {
      if (
        state.forxchange.offerRequest.contract.products[index].pictures[i]
          .intendedImageType
      ) {
        return false;
      }
    }
    return true;
  },
  getProductHasNoProducer: state => index => {
    if (
      state.forxchange.offerRequest.contract.products.length === 0 ||
      state.forxchange.offerRequest.contract.products[index] == undefined ||
      state.forxchange.offerRequest.contract.products[index].producer ==
      undefined
    ) {
      return true;
    }
    return (
      state.forxchange.offerRequest.contract.products[index].producer === ""
    );
  },
  getProductHasNoImei: (state, getters) => index => {
    if (
      state.forxchange.offerRequest.contract.products.length === 0 ||
      state.forxchange.offerRequest.contract.products[index] == undefined ||
      state.forxchange.offerRequest.contract.products[index].imei == undefined
    ) {
      return true;
    }
    return (
      state.forxchange.offerRequest.contract.products[index].imei === "" &&
      getters.getProductHasNoImeiPicture(index)
    );
  },
  getPhotoArray: state => productIndex => {
    if (
      state.forxchange.offerRequest.contract.products.length > 0 &&
      state.forxchange.offerRequest.contract.products[productIndex] !=
      undefined &&
      state.forxchange.offerRequest.contract.products[productIndex].pictures !=
      undefined
    ) {
      return state.forxchange.offerRequest.contract.products[productIndex]
        .pictures;
    }
    return [];
  },
  getPdfArray: state => productIndex => {
    if (
      state.forxchange.offerRequest.contract.products.length > 0 &&
      state.forxchange.offerRequest.contract.products[productIndex] !=
      undefined &&
      state.forxchange.offerRequest.contract.products[productIndex].files !=
      undefined
    ) {
      return state.forxchange.offerRequest.contract.products[productIndex]
        .files;
    }
    return [];
  },
  getPhotoAvailable: state => productIndex => {
    if (
      state.forxchange.offerRequest.contract.products.length > 0 &&
      state.forxchange.offerRequest.contract.products[productIndex] !=
      undefined &&
      state.forxchange.offerRequest.contract.products[productIndex].pictures
        .length > 0
    ) {
      return true;
    }
    return false;
  },
  getPdfAvailable: state => productIndex => {
    if (
      state.forxchange.offerRequest.contract.products.length > 0 &&
      state.forxchange.offerRequest.contract.products[productIndex] !=
      undefined &&
      state.forxchange.offerRequest.contract.products[productIndex].files
        .length > 0
    ) {
      return true;
    }
    return false;
  },
  getDialogProductDataInputState: state => {
    return state.dialogProductDataInputState;
  },
  getExportDataForDocumentService: state => {
    return state.forxchange;
  },
  getExportDataForSendService: state => {
    // Bereite spezielle Felder vor (products.product)
    let tmps = "";
    for (let prod of state.forxchange.offerRequest.contract.products) {
      tmps = prod.label + ";" + prod.producer;
      // Imei?
      if (prod.index < 3) {
        tmps += ";" + prod.imei;
      }
      prod.product = tmps;
    }
    // console.log("Vor der Rückgabe von state.forxchange für den SendService via getter");
    // console.dir(state.forxchange);
    // Ziehe eine Kopie der Exportdaten ohne Bilder
    let exportData = JSON.parse(JSON.stringify(state.forxchange)); // Copy, not reference
    // var cloneOfA = JSON.parse(JSON.stringify(a));
    for (let prod of exportData.offerRequest.contract.products) {
      prod.pictures = [];
    }

    // Rename partnernummer to partner_id for Send-Service if it exists
    if (exportData.offerRequest.policyholder.partnernummer) {
      exportData.offerRequest.policyholder.partner_id =
        exportData.offerRequest.policyholder.partnernummer;

      // Remove the original attribute
      delete exportData.offerRequest.policyholder.partnernummer;
    }
    // Important: If partnernummer doesn't exist, partner_id should not be included at all
    // No need for an else clause as we're not creating an empty partner_id

    // Liefere das Ergebnis aus
    // return state.forxchange;
    return exportData;
  },
  getExportDataForCheckService: state => {
    // Liefert eine Kopie der Exportdaten ohne Bilder
    let exportData = JSON.parse(JSON.stringify(state.forxchange)); // Copy, not reference
    // var cloneOfA = JSON.parse(JSON.stringify(a));
    for (let prod of exportData.offerRequest.contract.products) {
      prod.pictures = [];
    }
    return exportData;
  },
  getContractAcceptanceState: state => {
    return state.contractAcceptanceState;
  },
  getAnimationState: state => {
    return state.runIconAnimation;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
